import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@lenovo/material/dialog';
import { BaseHardwareScanModalComponent } from '../base-hardware-scan-modal';

@Component({
	selector: 'vtr-modal-recover-confirm',
	templateUrl: './modal-recover-confirm.component.html',
	styleUrls: ['./modal-recover-confirm.component.scss'],
})
export class ModalRecoverConfirmComponent extends BaseHardwareScanModalComponent {
	@Output() confirmClicked: EventEmitter<any> = new EventEmitter();

	constructor(private dialogRef: MatDialogRef<ModalRecoverConfirmComponent>) {
		super();
	}

	public onClosing() {
		this.dialogRef.close();
	}

	public confirmClick() {
		this.confirmClicked.emit();
		this.onClosing();
	}
}
